import { computed, effect } from "@angular/core";
import { patchState, signalStore, withComputed, withHooks, withMethods, withState } from "@ngrx/signals";
import { User, UserRole } from "../models/model";
import { loadStateFromStorage, saveStateToStorage } from "./utils-storage";


const STORAGE_KEY = 'userStore';

const defaultState: User = {
    id: '',
    name: '',
    firstname: '',
    email: '',
    role: UserRole.User,
    isActive: false,
    createdAt: '',
    updatedAt: ''
};

const storedState = loadStateFromStorage<User>(STORAGE_KEY);
const initialState: User = storedState
    ? { ...defaultState, ...storedState }
    : defaultState;

export const UserStore = signalStore(
    { providedIn: 'root' },
    withState(initialState),
    withComputed((store) => ({
        isLoggedIn: computed(() => !!store.id()),
        isAdmin: computed(() => store.role() === UserRole.Admin)
    })),
    withMethods((store) => ({
        logout: () => {
            patchState(store, { ...defaultState });
        },

        update(user: Partial<User>) {
            patchState(store, { ...user });
        }
    })),

    withHooks({
        onInit(store) {
            // Sauvegarder automatiquement à chaque changement d'état
            effect(() => {
                const state: User = {
                    id: store.id(),
                    name: store.name(),
                    firstname: store.firstname(),
                    role: store.role(),
                    email: '',
                    isActive: store.isActive(),
                    createdAt: '',
                    updatedAt: ''
                };

                saveStateToStorage(STORAGE_KEY, state);
            });
        }
    })
);